import {
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Offcanvas, Row } from "react-bootstrap";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
// import { Calendar, DateRangePicker } from 'react-date-range';
import { faClose, faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import NutritionContext from "../../../context/NutritionContext";
import dayjs from "dayjs";
import "./MealTracker.scss";

const FoodIntakeFilter = ({
  show,
  setShow,
  setCurrentPage,
  filterMealTypes,
  setFilterMealTypes,
  setResetPaginationToggle,
  resetPaginationToggle,
}) => {
  const handleClose = () => {
    setShow(false);
  };

  const { foodIntakeParam, setFoodIntakeParam } = useContext(NutritionContext);

  const [isClearFilter, setIsClearFilter] = useState(false);

  const [filterParam, setFilterParam] = useState({
    meal_type: "",
    is_validated: "",
    start_time: "",
    end_time: "",
    // start_time:new Date().toISOString(),
    // end_time:new Date().toISOString(),
  });

  const handleMealTypeChange = (event, value) => {
    const newMealType = value.includes("all") ? [] : value;

    setFilterMealTypes(newMealType);

    setFilterParam((prevVerificationListParam) => ({
      ...prevVerificationListParam,
      meal_type: newMealType?.length ? newMealType.join(",") : null,
    }));

    // const { name, checked } = event.target;
    // if (checked) {
    //   setFilterParam(prevState => ({
    //     ...prevState,
    //     meal_type: [...prevState.meal_type, name]
    //   }));
    // } else {
    //   setFilterParam(prevState => ({
    //     ...prevState,
    //     meal_type: prevState.meal_type.filter(item => item !== name)
    //   }));
    // }
  };

  const handleValidationChange = (event, value) => {
    setFilterParam((prevVerificationListParam) => ({
      ...prevVerificationListParam,
      is_validated: value !== "" ? value : "",
    }));
    // const { name } = event.target;
    // const newValue = name === 'completed' ? true : name === 'pending' ? false : "";

    // setFilterParam(prevState => ({
    //   ...prevState,
    //   is_validated: newValue
    // }));
  };

  const handleFilterSubmit = () => {
    setFoodIntakeParam((prevState) => ({
      ...prevState,
      ...filterParam,
      offset: 0,
    }));
    setCurrentPage(1);
    setResetPaginationToggle(!resetPaginationToggle);
    handleClose();
  };

  useEffect(() => {
    if (isClearFilter) {
      setFoodIntakeParam((prevState) => ({
        ...prevState,
        meal_type: "",
        is_validated: "",
        start_time: "",
        end_time: "",
        offset: 0,
      }));
      setIsClearFilter(false);
      setFilterMealTypes([]);
      setCurrentPage(1);
      setResetPaginationToggle(!resetPaginationToggle);
      handleClose();
    }
  }, [isClearFilter]);

  return (
    <div>
      <Offcanvas
        className="filter-modal"
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <FontAwesomeIcon icon={faFilter} /> Filter Intake
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <Chip
              label="Meal Type"
              variant="outlined"
              className="header-chip mb-2"
              color="secondary"
            />

            <ToggleButtonGroup
              color="secondary"
              // exclusive
              value={filterMealTypes}
              onChange={handleMealTypeChange}
              aria-label="text alignment"
              size="small"
              // className="mx-2"
            >
              <ToggleButton
                value={"all"}
                aria-label="all"
                className={
                  filterMealTypes.length !== 0 ? "" : "all-select-toogle"
                }
              >
                All
              </ToggleButton>
              <ToggleButton value={"breakfast"} aria-label="black">
                Breakfast
              </ToggleButton>
              <ToggleButton value={"lunch"} aria-label="lunch">
                Lunch
              </ToggleButton>
              <ToggleButton value={"dinner"} aria-label="dinner">
                Dinner
              </ToggleButton>
              <ToggleButton value={"snack"} aria-label="snack">
                Snack
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <div>
            <Chip
              label="Validated"
              variant="outlined"
              className="header-chip my-2"
              color="warning"
            />
            <ToggleButtonGroup
              color="secondary"
              exclusive
              value={filterParam.is_validated}
              onChange={handleValidationChange}
              aria-label="eligible filter"
              size="small"
              // className="mx-2"
            >
              <ToggleButton value={"" || null} aria-label="All">
                All
              </ToggleButton>
              <ToggleButton value={true} aria-label="completed">
                Completed
              </ToggleButton>
              <ToggleButton value={false} aria-label="pending">
                Pending
              </ToggleButton>
            </ToggleButtonGroup>
           
          </div>
          <div>
            <Chip
              label="Filter Date Range"
              variant="outlined"
              className="header-chip my-2"
              color="primary"
            />
            <Row className="date-range-picker my-1">
              <Col md={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      defaultValue={dayjs(new Date())}
                      label="Start Date"
                      format="DD-MM-YYYY"
                      value={dayjs(new Date(filterParam?.start_time)) || ""}
                      className="mb-2"
                      onChange={(newDate) => {
                        setFilterParam((prevState) => ({
                          ...prevState,
                          start_time: newDate.toISOString(),
                          end_time: filterParam?.end_time
                            ? filterParam?.end_time
                            : newDate.toISOString(),
                        }));
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Col>
              <Col md={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label="To Date"
                      format="DD-MM-YYYY"
                      value={dayjs(new Date(filterParam?.end_time)) || ""}
                      className="mb-2"
                      onChange={(newDate) => {
                        setFilterParam((prevState) => ({
                          ...prevState,
                          end_time: newDate.toISOString(),
                        }));
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Col>
            </Row>
          </div>
        </Offcanvas.Body>
        <Offcanvas.Header className="footer">
          <div>
            <Button
              variant="outline-danger"
              size="sm"
              className="my-2"
              onClick={() => {
                setIsClearFilter(true);
                setFilterParam({
                  meal_type: [],
                  is_validated: "",
                  start_time: "",
                  end_time: "",
                });
              }}
            >
              <FontAwesomeIcon icon={faClose} /> Clear Filter
            </Button>
          </div>
          <div>
            <Button
              variant="outline-primary"
              size="sm"
              className="my-2"
              onClick={() => {
                handleFilterSubmit();
              }}
            >
              <FontAwesomeIcon icon={faFilter} /> Filter List
            </Button>
          </div>
        </Offcanvas.Header>
      </Offcanvas>
    </div>
  );
};

export default FoodIntakeFilter;
